import { createSlice } from '@reduxjs/toolkit';

export const layoutSlice = createSlice({  
  name: 'layout',
  initialState: {
    accountMenuOpen: false,
    accountSidebarOpen: true,
    accountPageLoading: false,
    chatBotsSidebarOpen: true,
    chatBotsSchoolDetailsOpen: true,
  },
  reducers: {
    setAccountMenuOpen: (state) => {
      state.accountMenuOpen = !state.accountMenuOpen;
    },
    setAccountSidebarOpen: (state, action) => {
      state.accountSidebarOpen = action.payload || !state.accountSidebarOpen;
    },
    setAccountPageLoading: (state, action) => {
      state.accountPageLoading = typeof action.payload === 'boolean' ? action.payload : !state.accountPageLoading;
    },
    setChatBotsSidebarOpen: (state, action) => {
      state.chatBotsSidebarOpen = action.payload || !state.chatBotsSidebarOpen;
    },
    setChatBotsSchoolDetailsOpen: (state, action) => {
      state.chatBotsSchoolDetailsOpen = action.payload || !state.chatBotsSchoolDetailsOpen;
    },
  },
});

export const { setAccountMenuOpen, setAccountSidebarOpen, setAccountPageLoading, setChatBotsSidebarOpen, setChatBotsSchoolDetailsOpen } = layoutSlice.actions;

export default layoutSlice.reducer;